import { useEffect } from 'react';

const HtmlPixelSnippet = ({ snippet }) => {
  useEffect(() => {
    if (!snippet?.trim()) return;

    const container = document.createElement('div');
    container.innerHTML = snippet;
    const injectedNodes = [];

    Array.from(container.childNodes).forEach((node) => {
      if (node.nodeName.toLowerCase() === 'script') {
        const script = document.createElement('script');
        Array.from(node.attributes || []).forEach((attribute) => {
          script.setAttribute(attribute.name, attribute.value);
        });
        script.textContent = node.textContent || '';
        document.head.appendChild(script);
        injectedNodes.push(script);
        return;
      }

      const cloned = node.cloneNode(true);
      document.head.appendChild(cloned);
      injectedNodes.push(cloned);
    });

    return () => {
      injectedNodes.forEach((node) => {
        if (node.parentNode) {
          node.parentNode.removeChild(node);
        }
      });
    };
  }, [snippet]);

  return null;
};

export default HtmlPixelSnippet;
